var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('Info')],1),(_vm.styled.breakpoint.smAndUp)?_c('v-flex',{attrs:{"sm4":""}},[_c('QrCode')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }